import Vue from "vue"
import siteConfig from "@/utils/siteConfig"

export function createReward(data) {
  return Vue.axios.post(`${siteConfig.siteURL}admin/rewards`, data)
}

export function fetchRewardById(id) {
  return Vue.axios.get(`${siteConfig.siteURL}admin/rewards/${id}`)
}

export function putReward(id, data) {
  return Vue.axios.put(`${siteConfig.siteURL}admin/rewards/${id}`, data)
}

export function deleteReward(id) {
  return Vue.axios.delete(`${siteConfig.siteURL}admin/rewards/${id}`)
}
